import { Card } from "react-bootstrap";
import { InquiryEntryType } from "../../Types/inquiryTypes";
import timeService from "../../services/time/timeService";
import { Link } from "react-router-dom";

export default function InquiryEntry(props: {
    inquiry: InquiryEntryType,
}) {
    const { inquiry } = props;

    const {
        _id,
        name,
        email,
        phone,
        subject,
        message,
        created,
        extra
    } = inquiry;

    return (
        <Card className="mb-3">
            <Card.Body>
                <Card.Title>
                    <b>{name}</b>
                </Card.Title>
                <Card.Text>
                    <b>Email:</b> {email} <br />
                    {phone && (<><b>Phone:</b> {phone} <br /></>)}
                    <b>Created:</b> {timeService.getFormattedTime(created)} <br />
                    {subject && (<><b>Subject:</b> {subject} <br /></>)}
                    {extra && (<><b>Extra:</b> {extra} <br /></>)}
                </Card.Text>
                {message && (
                    <>
                        <b>Message:</b> <br />
                        <pre style={{
                            marginTop: '10px',
                            border: '1px solid #ddd',
                            borderRadius: '5px',
                            padding: '10px',
                        }}>
                            {message}
                        </pre>
                    </>
                )}
            </Card.Body>

            <Card.Footer>
                <Link className="btn btn-primary btn-sm me-2 mb-2" to={`/inquiry/${_id}`}>View</Link>
                <Link className="btn btn-secondary btn-sm me-2 mb-2" to={`/edit-inquiry/${_id}`}>Edit</Link>
                <Link className="btn btn-danger btn-sm me-2 mb-2" to={`/delete-inquiry/${_id}`}>Delete</Link>
            </Card.Footer>
        </Card>
    );
}
